


import { useState, CSSProperties } from "react";
import ClipLoader from "react-spinners/ClipLoader";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "blue",
};

interface SpinnerProperties {
    loading: boolean,
    size?: number 
}
const Spinner:React.FC<SpinnerProperties> = ({ loading, size=150})=>{
 
  let [color, setColor] = useState("#ffffff");

  return (
    <div className="sweet-loading w-[100%] max-h-[95vh] flex flex-col justify-center items-center">
     
      <ClipLoader 
        color={color}
        loading={loading}
        cssOverride={override}
        size={size}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

export default Spinner;